import {Component} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'zorrly-plain-wrapper',
  standalone: true,
  imports: [CommonModule],
  template: `
      <ng-container #fieldComponent></ng-container>
  `
})
export class ZorrlyPlainWrapperComponent extends FieldWrapper {
}


